const homeConfig = {
    'name': "I'M Ritesh Dabral.",
    'subHeadings': ["Backend focused", "Full Stack Dev"],
    'description': "Indian-bred tech architect wielding both backend expertise and full-stack mastery. I forge performant solutions with clean code, outsmarting challenges with innovative thinking, and crafting impactful products that touch lives. Driven by the belief that software can elevate, I build for good, one line of code at a time.",
    'cta':"More about me"
}

export {
    homeConfig
}